import React from 'react';

import {
  Box, Button,
  Paper, Stack, Typography
} from '@mui/material';


import { useAppAuthContext } from '../../utils/AppAuthContext.js';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig.js';
import { InteractionType } from '@azure/msal-browser';




const LoginOiDCPage = () => {

  const { instance,inProgress } = useMsal(); 
  const {loginComplete,processingLogin} = useAppAuthContext();
  const doLoginOidc = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch(e => {
        console.log(e);
      });
    } else if (loginType === "redirect") {
      sessionStorage.clear()
      instance.loginRedirect(loginRequest).catch(e => {
        console.log(e);
      });
    }
  }


  const doLoginOidcRedirect = () => {
    doLoginOidc("redirect")
  }




  return (
    <Box>

      <Paper sx={{ p: 10 }} elevation={0} >
        <Stack
          container
          spacing={2}
          direction={'column'}
          justify={'center'}
          alignItems={'center'}
        >
          {
            inProgress === InteractionType.None && !processingLogin && 
            <Button
              color='success'
              sx={{ width: 300 }}
              size='large'
              variant='contained' onClick={doLoginOidcRedirect}
            >Login</Button>

          }

          {
           ( inProgress !== InteractionType.None || processingLogin) && !loginComplete &&
            <Typography variant='h6' sx={{align:'center'}} > 
            <small>Loading</small>
            </Typography>
         }

        
          



        </Stack>


      </Paper>


    </Box>
  );
}

export default LoginOiDCPage
